var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCaution(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4234_157",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 3,
    width: 4,
    height: 14
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.33398 3.3335H11.186V16.7635H8.33398V3.3335Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4234_157)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.76376 16.3605C8.50113 16.0914 8.37036 15.7579 8.37036 15.3569C8.37036 14.957 8.50113 14.6224 8.76376 14.3532C9.02639 14.0841 9.35767 13.95 9.7587 13.95C10.1586 13.95 10.4899 14.0841 10.7525 14.3532C11.0152 14.6224 11.147 14.957 11.147 15.3569C11.147 15.7579 11.0152 16.0914 10.7525 16.3605C10.4899 16.6297 10.1586 16.7638 9.7587 16.7638C9.35767 16.7638 9.02639 16.6297 8.76376 16.3605ZM9.28011 12.6368C9.14825 12.5114 9.06979 12.3305 9.04581 12.093L8.35165 4.79605L8.33203 4.60861C8.33203 4.22175 8.46825 3.91226 8.73633 3.68015C9.00549 3.44912 9.3444 3.33252 9.75851 3.33252C10.1704 3.33252 10.5115 3.44912 10.7807 3.68015C11.0488 3.91226 11.185 4.22175 11.185 4.60861L11.1643 4.81566L10.4712 12.093C10.4461 12.3305 10.3677 12.5114 10.2369 12.6368C10.105 12.7621 9.94703 12.8242 9.75851 12.8242C9.57107 12.8242 9.41088 12.7621 9.28011 12.6368Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaution);
export default __webpack_public_path__ + "static/media/caution.c34cb3cd9d7279f920679334815cdc19.svg";
export { ForwardRef as ReactComponent };